<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content below * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced.  * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * Delete the template below * * * * * * * * * -->
<!-- * * * * * * * to get started with your project! * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<nb-layout>
  <nb-layout-header
    fixed
    [class.background-red]="isGemHdPage()"
    [class.background-neutral]="!isGemHdPage()"
    [class.neutral-header]="!isGemHdPage()"
  >
    <div class="width-full flex-x-between">
      <div class="flex-x">
        <!-- GeM-HD wordmark only on the GWAS 1-5 / 1-6 studies; neutral title everywhere else -->
        <img
          *ngIf="isGemHdPage()"
          src="assets/typeface-logo/GEM-HD.svg"
          class="margin-block-auto margin-right-1 cursor-pointer"
          routerLink="/home"
         alt="GEM-HD logo"/>
        <a
          *ngIf="!isGemHdPage()"
          routerLink="/home"
          class="neutral-title margin-block-auto margin-right-1 cursor-pointer"
        >HD GWAS Viewer</a>

        <!-- Dataset dropdown - only shown on GWAS 1-6 display pages (not on initial selection) -->
        <div *ngIf="isGwas16DisplayPage()" class="dataset-dropdown">
          <!-- Loading State -->
          <div *ngIf="!datasets.length && !error" class="dropdown-loading">
            <div class="loading-spinner"></div>
            <span>Loading...</span>
          </div>

          <!-- Dropdown -->
          <div *ngIf="datasets.length > 0" class="dropdown-container">
            <nb-select
              placeholder="Select Dataset"
              [selected]="currentDataset"
              (selectedChange)="changeDataset($event)"
              status="basic"
              size="small"
              class="header-select"
            >
              <nb-option *ngFor="let dataset of datasets" [value]="dataset.name">
                {{ dataset.display_name ? dataset.display_name : dataset.name }}
              </nb-option>
            </nb-select>
          </div>

          <!-- Error State -->
          <div *ngIf="error" class="dropdown-error">
            <span>Error loading datasets</span>
          </div>
        </div>
      </div>

      <div class="flex-x column-gap-1">
        <button
          nbButton
          status="primary"
          routerLink="/about"
          [class.border-bottom-white]="router.url.startsWith('/about')"
        >
          About
        </button>
        <button
          nbButton
          status="primary"
          routerLink="/contact"
          [class.border-bottom-white]="router.url.startsWith('/contact')"
        >
          Contact
        </button>
        <!-- Publications + Sponsors are GeM-HD content: shown only in the GeM-HD area (GWAS 1-5 /
             1-6 studies and these pages themselves), not on the neutral landing or Enroll-HD WGS+ -->
        <button
          *ngIf="isGemHdPage()"
          nbButton
          status="primary"
          routerLink="/publications"
          [class.border-bottom-white]="router.url.startsWith('/publications')"
        >
          Publications
        </button>
        <button
          *ngIf="isGemHdPage()"
          nbButton
          status="primary"
          routerLink="/sponsors"
          [class.border-bottom-white]="router.url.startsWith('/sponsors')"
        >
          Sponsors
        </button>
        <button
          nbButton
          status="primary"
          routerLink="/downloads"
          [class.border-bottom-white]="router.url.startsWith('/downloads')"
        >
          Downloads
        </button>
        <button
          *ngIf="!isLoggedIn()"
          nbButton
          class="margin-left-2"
          shape="semi-round"
          size="small"
          (click)="login()"
        >
          Login/Sign-Up
        </button>
        <button
          *ngIf="isLoggedIn()"
          nbButton
          class="margin-left-2"
          shape="semi-round"
          size="small"
          (click)="logout()"
        >
          Logout
        </button>
      </div>
    </div>
  </nb-layout-header>

  <nb-layout-column
    class="margin-inline-auto max-width-6"
    [class.neutral-study]="!isGemHdPage()"
  >
    <router-outlet></router-outlet>
  </nb-layout-column>

</nb-layout>

<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content above * * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced.  * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * End of Placeholder  * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
